import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import TextInfo, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
} from '@gc-npm/components.text';
import Carousel from '@gc-npm/components.carousel';

import MobilesLinesModal from '@/components/Modals/MobilesLinesModal';
import { mobileLinesModalNavigationProps } from '@/utils/mobile-lines-modal';
import { buildAndRenderProductCard } from '@/utils/recomendador';
import { API_STATUS, SCREEN_TYPES } from '@/utils/constants';
import UpgradePrices from "@/components/UpgradePrices"

export const BestSellers = ({
  screenType,
}) => {
  const dispatch = useDispatch();

  const bestSellers = useSelector(
    (state) => state.recomendator?.data?.recomAndBestSellers?.bestSellers,
  );
  const status = useSelector(
    (state) => state.recomendator?.status?.init,
  );
  const modulos = useSelector((state) => state.modulos);

  const isLoaded = status === API_STATUS.OK;
  const isMobile = screenType === SCREEN_TYPES.MOBILE;
  const taggingInfo = { debug: true };

  if (!bestSellers) {
    return null;
  }

  const onclickMobileLinesModal = (linesToSelect) => {
    dispatch(
      modalActions.addModal({
        id: 'MobileLinesModal',
        Element2Show: MobilesLinesModal,
        modalProps: {
          closeByClickingOutside: true,
          contentPosition: isMobile ? 'center--bottom' : 'center--center',
          inSceneEffect: isMobile ? 'fadeInBottom' : 'fadeIn',
          outSceneEffect: isMobile ? 'fadeOutBottom' : 'fadeOut',
          opacityLayoutColor: 'blur',
          scrollAllowed: false,
          taggingInfoWhenClickingOutside: {
            ...taggingInfo,
            componentName: 'mobileLinesModal',
            componentContent: 'cerrar',
          },
          ...mobileLinesModalNavigationProps,
        },
        elementProps: {
          screenType,
          linesToSelect,
        },
      }),
    );
  };
  return (
    <div className="BestSellers">
      <div className="BestSellers_wrapper container">
        <div className="BestSellers_title">
          <TextInfo
            text="Packs más vendidos"
            size={TEXT_SIZE.T3}
            color={TEXT_COLOR.MOVISTAR_BLACK}
            kind={TEXT_KIND.HEADING}
            level={TEXT_HEADING_LEVEL.H2}
            fontType={TEXT_FONT_WEIGHT.BOLD}
            align={TEXT_ALIGN.JUSTIFY}
          />
        </div>
   
        <Carousel slideSeparation={18} maxPointNum={4}>
          {bestSellers.map(
            (bestSeller) => buildAndRenderProductCard(
              dispatch,
              bestSeller,
              null,
              onclickMobileLinesModal,
              isLoaded,
            ),
          )}
        </Carousel>
     {modulos?.legalTexts &&(
          <UpgradePrices/>
        )}
      </div>
      <style jsx>
        {`
          .BestSellers {
            &_wrapper {
              display: flex;
              flex-direction: column;
              gap: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default BestSellers;
